import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from '../views/DashboardView.vue'
import ManagementLayout from '../components/management/ManagementLayout.vue'
import { useAuthStore } from '../store/auth'
import { checkAuthRoute } from '../utils/authNavigation.mjs'
import { CAPABILITIES } from '../utils/permissions.mjs'

const SITE_TITLE = '地脉动监测预警系统'

const routes = [
  { path: '/account-management', component: () => import('../views/AccountManagementView.vue') },
  {
    path: '/',
    name: 'Dashboard',
    component: DashboardView,
    meta: { requiresAuth: true } // 需要登录访问
  },
  {
    path: '/dashboard/grid',
    name: 'DashboardGrid',
    component: () => import('../views/GridDashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/devices',
    redirect: { name: 'ManagementDevices' }
  },
  {
    path: '/monitor/:sid',
    name: 'Monitor',
    component: () => import('../views/MonitorView.vue'),
    meta: { requiresAuth: true, title: '设备监测详情' }
  },
  {
    path: '/manage',
    component: ManagementLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'ManagementOverview',
        component: () => import('../views/management/OverviewView.vue'),
        meta: { requiresAuth: true, title: '管理总览' }
      },
      {
        path: 'projects',
        name: 'ManagementProjects',
        component: () => import('../views/management/ProjectsView.vue'),
        meta: { requiresAuth: true, title: '项目管理' }
      },
      {
        path: 'projects/:projectId',
        name: 'ManagementProjectDetail',
        component: () => import('../views/management/ProjectDetailView.vue'),
        meta: { requiresAuth: true, title: '项目详情' }
      },
      {
        path: 'devices',
        name: 'ManagementDevices',
        component: () => import('../views/management/DevicesView.vue'),
        meta: { requiresAuth: true, title: '设备管理' }
      },
      {
        path: 'devices/:sid',
        name: 'ManagementDeviceDetail',
        component: () => import('../views/management/DeviceDetailView.vue'),
        meta: { requiresAuth: true, title: '设备详情' }
      },
      {
        path: 'assistants',
        name: 'ManagementAssistants',
        component: () => import('../views/management/AssistantsView.vue'),
        meta: { requiresAuth: true, title: '传输助手' }
      },
      {
        path: 'assistant-monitor',
        name: 'ManagementAssistantMonitor',
        component: () => import('../views/management/AssistantMonitorView.vue'),
        meta: { requiresAuth: true, requiredCapability: CAPABILITIES.ASSISTANT_MONITOR, title: '助手监控' }
      },
      {
        path: 'server-capacity',
        name: 'ManagementServerCapacity',
        component: () => import('../views/management/ServerCapacityView.vue'),
        meta: { requiresAuth: true, requiredCapability: CAPABILITIES.SERVER_CAPACITY_READ, title: '服务器容量' }
      },
      {
        path: 'batches',
        name: 'ManagementBatches',
        component: () => import('../views/management/BatchesView.vue'),
        meta: { requiresAuth: true, title: '接入记录' }
      },
      {
        path: 'notifications',
        name: 'ManagementNotifications',
        component: () => import('../views/management/NotificationsView.vue'),
        meta: { requiresAuth: true, title: '通知中心' }
      }
    ]
  },
  {
    path: '/microseismic/events',
    name: 'MicroseismicEvents',
    component: () => import('../views/MicroseismicEventsView.vue'),
    meta: { requiresAuth: true, title: '微震事件' }
  },
  {
    path: '/microseismic/events/:eventId',
    name: 'MicroseismicEventDetail',
    component: () => import('../views/MicroseismicEventDetailView.vue'),
    meta: { requiresAuth: true, title: '微震事件详情' }
  },
  {
    path: '/alerts',
    name: 'EnvelopePending',
    component: () => import('../views/WarningUnavailableView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/alerts/:eventId/evidence',
    name: 'AlertEvidence',
    redirect: to => ({ name: 'MicroseismicEventDetail', params: { eventId: to.params.eventId } })
  },
  {
    path: '/alerts/history',
    name: 'EnvelopeHistory',
    component: () => import('../views/WarningUnavailableView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/envelope-alerts',
    name: 'EnvelopeAlertSettings',
    component: () => import('../views/EnvelopeAlertSettingsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue'),
    meta: { requiresAuth: false } // 登录页不需要认证
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 首次导航等待后端身份核验，避免页面先使用旧缓存显示另一个账号的数据。
router.beforeEach(to => checkAuthRoute(to, useAuthStore()))

router.afterEach(to => {
  const pageTitle = to.meta?.title
  document.title = pageTitle ? `${pageTitle} - ${SITE_TITLE}` : SITE_TITLE
})

export default router
